module.exports = __webpack_public_path__ + "media/images/lb/415-92a8f42f4b354ead3d635042fcfa60ed.svg";